export const PAGE_IDS: Record<string, string> = {
    personal: '05ffc7a6-c46d-433e-8309-20866c59d602',
    addressInfo: '10187791-dab9-437b-b9c1-8e2437f7455e',
    studentDetails: 'c9315d28-45ac-4cf3-8083-db7c0036a4a8',
    secondaryEducation: '289b64b9-c60b-4de7-8ef2-016251ac9843',
    postSecondaryEducation: '3df0d59b-17ed-4e4f-8e62-f663b140558e',
    militaryInfo: '43841553-62ae-42fa-8e1d-6faa54e59d71',
    employmentInfo: '54abef66-127b-401e-b74b-955d36fcad45',
    ferpa: '7c3f3f3e-5d2e-4f4b-9f1e-2b2e4f4c5d6f', 
    emergencyContact: '8d4f4e4c-3b2a-4c5d-9f1e-7c3f3f3e5d2e',
    optIn1098T: 'a1f5e6d7-c4b3-4a2d-8e1f-9c3b5d7e9f1a',
    references: '9e5d6f7c-4f4b-5d2e-3b2a-1e2b3c4d5e6f',
    housing: 'c0670c61-31cb-4017-a067-ed55af273277',
    housingDetails: 'f1a2b3c4-d5e6-4708-9a1b-2c3d4e5f6071',
    housingPreviousAddress: 'a2b3c4d5-e6f7-4819-8b2c-3d4e5f607182',

    // Program Enrollment per-panel resume GUIDs (mirror CompletedPageHelper.Page.Enrollment_*)
    enrollmentReviewSelection: 'b3c4d5e6-f708-4a1b-9c2d-3e4f5a6b7c81',
    enrollmentNursingHistory: 'c4d5e6f7-081a-4b2c-8d3e-4f5a6b7c8d92',
    enrollmentDriversLicense: 'd5e6f708-1a2b-4c3d-9e4f-5a6b7c8d9e03',
    enrollmentHousingPlans: 'e6f7081a-2b3c-4d4e-8f5a-6b7c8d9e0f14',
    enrollmentBackgroundCheck: 'f7081a2b-3c4d-4e5f-9a6b-7c8d9e0f1a25',
    enrollmentOptIn1098T: '081a2b3c-4d5e-4f60-8b7c-8d9e0f1a2b36',
    enrollmentFerpa: '1a2b3c4d-5e6f-4071-9c8d-9e0f1a2b3c47',
    enrollmentEmergencyContact: '2b3c4d5e-6f70-4182-8d9e-0f1a2b3c4d58',
    enrollmentReferences: '3c4d5e6f-7081-4293-9e0f-1a2b3c4d5e69',
    // Mirrors CompletedPageHelper.Page.Enrollment_Documents (the step between References and Application Fees).
    enrollmentDocuments: '4e5f6071-8293-44a5-8b1c-2d3e4f5a6b7c',

    // Financial per-panel resume GUIDs (mirror CompletedPageHelper.Page.Financial_*)
    financialFsa: '4d5e6f70-8192-43a4-8f10-2b3c4d5e6f71',
    financialFafsa: '5e6f7081-92a3-44b5-9021-3c4d5e6f7082',
    financialMeeting: '6f708192-a3b4-45c6-8132-4d5e6f708193',
    financialEntranceCounseling: '708192a3-b4c5-46d7-9243-5e6f708192a4',
    financialMpn: '8192a3b4-c5d6-47e8-8354-6f708192a3b5',

    // Admissions Interview per-panel resume GUIDs (mirror CompletedPageHelper.Page.AdmissionsInterview_*)
    interviewIntro: '92a3b4c5-d6e7-48f9-9465-708192a3b4c6',
    interviewBooking: 'a3b4c5d6-e7f8-4901-8576-8192a3b4c5d7',

};
